import React from "react";
import { useParams, Link as RouterLink } from "react-router-dom";
import { Box, Typography, Paper, List, ListItemButton, ListItemText, Divider } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditNoteIcon from "@mui/icons-material/EditNote";

// Point d'entrée pour la saisie des pénalités télémark — liste les postes
// disponibles pour cet event_key, chacun menant à sa propre page
// SaisiePenalite.jsx (un juge = un poste = category+parity+slot), plus un
// lien vers la vue d'ensemble (tous les postes croisés par dossard, pour
// contrôler ou corriger directement).
// URL : /saisiepenalite/:eventKey
//
// Dispositif "beau temps" (27.08.2026) : jusqu'à 2 juges style + 1 juge
// jump par parité de dossard. En configuration réduite, il suffit de
// n'utiliser que certains de ces liens (ex: 1 seul juge style au lieu de
// 2) — les pénalités s'additionnent quel que soit le nombre de postes
// effectivement utilisés (voir telemarkResultsRouter.js).

const STATIONS = [
    { category: "style", parity: "pair", slot: 1, label: "Style — dossards pairs — Juge 1" },
    { category: "style", parity: "pair", slot: 2, label: "Style — dossards pairs — Juge 2" },
    { category: "jump", parity: "pair", slot: 1, label: "Jump — dossards pairs" },
    { category: "style", parity: "impair", slot: 1, label: "Style — dossards impairs — Juge 1" },
    { category: "style", parity: "impair", slot: 2, label: "Style — dossards impairs — Juge 2" },
    { category: "jump", parity: "impair", slot: 1, label: "Jump — dossards impairs" },
];

export default function SaisiePenaliteHub() {
    const { eventKey } = useParams();

    return (
        <Box sx={{ minHeight: "100vh", bgcolor: "#f5f5f5", p: 2 }}>
            <Typography variant="h6" sx={{ fontWeight: "bold", mb: 0.5 }}>
                Pénalités — {eventKey}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Choisissez votre poste ci-dessous. En configuration réduite, seuls certains liens sont
                utilisés (ex: un seul juge Style au lieu de deux) — les saisies s'additionnent quel que
                soit le nombre de postes actifs.
            </Typography>

            <Paper variant="outlined" sx={{ borderRadius: 2, mb: 2 }}>
                <List disablePadding>
                    <ListItemButton
                        component={RouterLink}
                        to={`/saisiepenalite/${eventKey}/overview`}
                        sx={{ py: 2 }}
                    >
                        <VisibilityIcon sx={{ mr: 1.5, color: "primary.main" }} />
                        <ListItemText
                            primary="Vue d'ensemble — contrôle et correction"
                            secondary="Tous les postes croisés par dossard, saisie directe possible"
                        />
                    </ListItemButton>
                    <Divider component="li" />
                    <ListItemButton
                        component={RouterLink}
                        to={`/saisiepenalite/${eventKey}/solo`}
                        sx={{ py: 2 }}
                    >
                        <EditNoteIcon sx={{ mr: 1.5, color: "primary.main" }} />
                        <ListItemText primary="Saisie solo" />
                    </ListItemButton>
                </List>
            </Paper>

            <Paper variant="outlined" sx={{ borderRadius: 2 }}>
                <List disablePadding>
                    {STATIONS.map((s, i) => (
                        <React.Fragment key={`${s.category}-${s.parity}-${s.slot}`}>
                            {i > 0 && <Divider component="li" />}
                            <ListItemButton
                                component={RouterLink}
                                to={`/saisiepenalite/${eventKey}/${s.category}/${s.parity}/${s.slot}`}
                                sx={{ py: 2 }}
                            >
                                <ListItemText primary={s.label} />
                            </ListItemButton>
                        </React.Fragment>
                    ))}
                </List>
            </Paper>
        </Box>
    );
}